import { Box, Button, ButtonGroup, Card, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import 'dayjs/locale/nl';
import { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from '../../../app/AppStyles';
import { postStudentRemark, putStudentRemark } from './searchStudentSlice';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: { xs: '90%', md: '40%' },
    maxHeight: '90%',
    boxShadow: 24,
};

export default function SearchStudentRemarkCard({ handleClose, addNew, studentId, selectedRemark }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { putStudentRemarkStatus, postStudentRemarkStatus } = useSelector((state) => state.search.student);
    const { activeDepartment } = useSelector((state) => state.settings.theme);
    const { siomSettings } = useSelector((state) => state.settings.siom);

    // Put status callback
    useEffect(() => {
        if (putStudentRemarkStatus === "success") {
            handleClose();
        }
    }, [dispatch, studentId, handleClose, putStudentRemarkStatus, activeDepartment, siomSettings]);

    // Post status callback
    useEffect(() => {
        if (postStudentRemarkStatus === "success") {
            handleClose();
        }
    }, [dispatch, studentId, handleClose, postStudentRemarkStatus, activeDepartment, siomSettings]);

    // Property states
    const [newRemark, setNewRemark] = useState({});
    const [changed, setChanged] = useState(false);

    // Selected remark state update 
    useEffect(() => {
        if (!addNew && selectedRemark)
            setNewRemark(selectedRemark);
    }, [selectedRemark, addNew]);

    // Keep track of changed state 
    useEffect(() => {
        if (newRemark !== selectedRemark) {
            setChanged(true);
        } else {
            setChanged(false);
        };
    }, [selectedRemark, newRemark]);

    // Add click function
    const handleAddClick = () => {
        newRemark.StudentId = studentId;
        newRemark.EmployeeId = user.userId;
        newRemark.CreatedBy = `AP/${user.number}`;

        dispatch(postStudentRemark(newRemark));
    };

    // Update click function
    const handleUpdateClick = () => {
        newRemark.RemarkId = selectedRemark.id;
        newRemark.StudentId = selectedRemark.userId;
        newRemark.EmployeeId = user.userId;
        newRemark.ModifiedBy = `AP/${user.number}`;

        dispatch(putStudentRemark(newRemark));
    };

    return (
        <Box sx={{ ...modalStyle }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', p: 2 }}>
                <Scrollbars autoHeight autoHeightMin="100%" autoHeightMax="100%" autoHideTimeout={1000} autoHideDuration={200}>
                    <Grid container spacing={1}>
                        <Grid size={{ xs: 12 }}>
                            <Typography variant="h6" sx={{ ...PageHeader }}>{resourceFinal[appLanguage].words.REMARK} {addNew ? resourceFinal[appLanguage].words.ADD.toLowerCase() : resourceFinal[appLanguage].words.EDIT.toLowerCase()}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <TextField
                                fullWidth required multiline
                                defaultValue={selectedRemark?.remarkText}
                                label={resourceFinal[appLanguage].words.REMARK}
                                onChange={(event) => setNewRemark({
                                    ...newRemark,
                                    remarkText: event.target.value
                                })}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <FormControlLabel
                                label={`${resourceFinal[appLanguage].messages.VISIBLE_FOR_STUDENTS}`}
                                control={<Checkbox
                                    defaultChecked={selectedRemark?.visibleForStudent}
                                    onChange={(event) => setNewRemark({
                                        ...newRemark,
                                        visibleForStudent: event.target.checked ? true : false
                                    })}
                                />}
                            />
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <FormControlLabel
                                label={`${resourceFinal[appLanguage].messages.VISIBLE_FOR_EMPLOYEES}`}
                                control={<Checkbox
                                    defaultChecked={selectedRemark?.visibleForEmployee}
                                    onChange={(event) => setNewRemark({
                                        ...newRemark,
                                        visibleForEmployee: event.target.checked ? true : false
                                    })}
                                />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <ButtonGroup sx={{ justifyContent: 'center' }}>
                                <Button variant="outlined" color="error" onClick={handleClose}>{resourceFinal[appLanguage].words.CANCEL}</Button>
                                {!addNew && <Button disabled={!changed} variant="outlined" color="primary" onClick={handleUpdateClick}>{resourceFinal[appLanguage].words.SAVE}</Button>}
                                {addNew && <Button disabled={!changed} variant="outlined" color="primary" onClick={handleAddClick}>{resourceFinal[appLanguage].words.ADD}</Button>}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </Scrollbars>
            </Card>
        </Box>
    );
}
